import axios from "axios";

const Axios = axios.create();

// function to set userId header
export const setAxiosUserId = (userId) => {
  if (userId) {
    Axios.defaults.headers.common["X-UserId"] = userId;
  } else {
    delete Axios.defaults.headers.common["X-UserId"];
  }
};

// Response interceptor
Axios.interceptors.response.use(
  (res) => res,
  (err) => {
    if (!err.response) {
      console.error("No response from server:", err);
    }
    return Promise.reject(err);
  }
);

export const handelError = (Err) => {
  let errMsg = "Something Went Wrong";
  if (Err?.message) errMsg = Err.message;
  return {
    error: true,
    message: errMsg,
  };
};

export const header = {
  headers: {
    "Content-Type": "application/json",
  },
};

export default Axios;
